// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__4QFol","navbar_cont":"styles_navbar_cont__2nmta","collapseArea":"styles_collapseArea__3qJ7x"};